import WhDocument from "../../../../services/wh-document.service";
import moment from 'moment'
import {mapGetters, mapState} from "vuex";
import {isKorean} from "element-ui/src/utils/shared";

const Income = {
	/**
	 * Props
	 */
	props: {
		section: {
			type: String,
			default: 'kirim'
		}
	},

	/**
	 * Create
	 */
	created() {
		//load items
		if (!this.isTabChanged) {
			if (this.section == 'kirim' || this.customTabIndex == 0) {
				this.loadIncomes();
			}
		}
	},

	/**
	 * Data

	 */
	data() {
		return {
			isFilterItemsExecuted: false,
			items: [],
			total: 0,
			loader: true,
			fields: [],
			search: {
				page: this.$route.query.page ? Number(this.$route.query.page) : 1,
				limit: 20,
			},
			filterSearch: {},
			paramsFromSearch: null
		}
	},

	/**
	 * Methods
	 */
	methods: {

		/**
		 * Load items
		 */
		loadIncomes() {
			this.loader = true;
			const params = Object.assign({}, this.search);
			if (this.section === 'kirim') {
				let newFilterSearch = {}

				newFilterSearch.page = this.search.page
				newFilterSearch.limit = this.search.limit

				if (Object.keys(this.filterSearch).length !== 0) {
					if (this.filterSearch.regDate.value !== '' && this.filterSearch.regDate.value !== null)
						newFilterSearch.startDate = this.filterSearch.regDate.value
					if (this.filterSearch.regDate.value2 !== '' && this.filterSearch.regDate.value2 !== null)
						newFilterSearch.endDate = this.filterSearch.regDate.value2

					if (this.filterSearch.department !== null) {
						let arr = []
						arr.push(this.filterSearch.department)
						newFilterSearch.toDepartmentIds = arr
					}

					if (this.filterSearch.contragent !== null) {
						let arr = []
						arr.push(this.filterSearch.contragent)
						newFilterSearch.contragentIds = arr
					}


					if (this.filterSearch.regNumber !== null && this.filterSearch.regNumber !== '')
						newFilterSearch.regNumber = this.filterSearch.regNumber

				}
				WhDocument.searchManualKirim(newFilterSearch).then(response => {
					this.isFilterItemsExecuted = false;
					this.items = response.data.items;
					this.total = response.data.total;
					this.loader = false;
					this.tabChanged = false;
					this.search.attributes = [];
				}).catch((error) => {
					this.isFilterItemsExecuted = false;
					this.loader = false;
					this.tabChanged = false;
					const err = JSON.parse(error.request.response);
					this.$vs.notify({
						title: this.$t('words.error'),
						text: err.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				});
			} else if (this.section === 'kochirish') {
				if (this.tabName == 'sended') {
					let newFilterSearch2 = {}
					newFilterSearch2.page = this.search.page
					newFilterSearch2.limit = this.search.limit
					if (Object.keys(this.filterSearch).length !== 0) {
						if (this.filterSearch.regDate.value !== '' && this.filterSearch.regDate.value !== null)
							newFilterSearch2.startDate = this.filterSearch.regDate.value
						if (this.filterSearch.regDate.value2 !== '' && this.filterSearch.regDate.value2 !== null)
							newFilterSearch2.endDate = this.filterSearch.regDate.value2
						if (this.filterSearch.department !== null) {
							let arr = [];
							arr.push(this.filterSearch.department.id);
							newFilterSearch2.fromDepartmentIds = arr;
						}
						if (this.filterSearch.toDepartment !== null) {
							let arr = [];
							arr.push(this.filterSearch.toDepartment.id);
							newFilterSearch2.toDepartmentIds = arr;
						}
						if (this.filterSearch.regNumber !== null && this.filterSearch.regNumber !== '')
							newFilterSearch2.regNumber = this.filterSearch.regNumber
					}
					WhDocument.searchTransferKirim(newFilterSearch2).then(response => {
						this.isFilterItemsExecuted = false;
						this.items = response.data.items;
						this.total = response.data.total;
						this.loader = false;
						this.search.attributes = [];
					}).catch((error) => {
						this.isFilterItemsExecuted = false;
						this.loader = false;
						const err = JSON.parse(error.request.response);
						this.$vs.notify({
							title: this.$t('words.error'),
							text: err.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					});
				} else if (this.tabName == 'received') {
					let newObj = {};
					newObj = {
						page: this.search.page,
						limit : this.search.limit,
						attributes: !this.paramsFromSearch?this.attributes:this.paramsFromSearch
					}
					WhDocument.search(newObj, "kochirish").then(response => {
						this.isFilterItemsExecuted = false;
						this.items = response.data.items;
						this.total = response.data.total;
						this.loader = false;
						this.tabChanged = false;
						this.search.attributes = [];
					}).catch((error) => {
						this.isFilterItemsExecuted = false;
						this.loader = false;
						this.tabChanged = false;
						const err = JSON.parse(error.request.response);
						this.$vs.notify({
							title: this.$t('words.error'),
							text: err.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					});
				} else if (this.tabName == 'suspend') {
					let newObj = {};
					newObj = {
						page: this.search.page,
						limit : this.search.limit,
						attributes: !this.paramsFromSearch?this.attributes:this.paramsFromSearch
					}
					WhDocument.searchTransferSuspend(newObj).then(response => {
						this.isFilterItemsExecuted = false;
						this.items = response.data.items;
						this.total = response.data.total;
						this.loader = false;
						this.tabChanged = false;
						this.search.attributes = [];
					}).catch((error) => {
						this.isFilterItemsExecuted = false;
						this.loader = false;
						this.tabChanged = false;
						const err = JSON.parse(error.request.response);
						this.$vs.notify({
							title: this.$t('words.error'),
							text: err.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					});
				} else if (this.tabName == 'pending') {
					let newFilterSearch3 = {}
					newFilterSearch3.page = this.search.page
					newFilterSearch3.limit = this.search.limit
					if (Object.keys(this.filterSearch).length !== 0) {
						if (this.filterSearch.regDate.value !== '' && this.filterSearch.regDate.value !== null)
							newFilterSearch3.startDate = this.filterSearch.regDate.value
						if (this.filterSearch.regDate.value2 !== '' && this.filterSearch.regDate.value2 !== null)
							newFilterSearch3.endDate = this.filterSearch.regDate.value2
						if (this.filterSearch.department !== null) {
							newFilterSearch3.fromDepartment = this.filterSearch.department.id
						}
						if (this.filterSearch.toDepartment !== null) {
							newFilterSearch3.toDepartment = this.filterSearch.toDepartment.id;
						}
						if (this.filterSearch.regNumber !== null && this.filterSearch.regNumber !== '')
							newFilterSearch3.regNumber = this.filterSearch.regNumber
					}
					WhDocument.pending(newFilterSearch3).then(response => {
						this.isFilterItemsExecuted = false;
						this.pending.items = response.data.items;
						this.total = response.data.total;
						this.pending.loaded = true;
						this.tabChanged = false;
						this.loader = false
					}).catch((error) => {
						this.isFilterItemsExecuted = false;
						this.loader = false;
						const err = JSON.parse(error.request.response);
						this.$vs.notify({
							title: this.$t('words.error'),
							text: err.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					});
				} else if (this.tabName == 'waiting') {
					let newObj = {};
					newObj = {
						page: this.search.page,
						limit : this.search.limit,
						attributes: !this.paramsFromSearch?this.attributes:this.paramsFromSearch
					}
					WhDocument.searchTransferWaiting(newObj).then(response => {
						this.isFilterItemsExecuted = false;
						this.items = response.data.items;
						this.total = response.data.total;
						this.loader = false;
						this.tabChanged = false;
						this.search.attributes = [];
					}).catch((error) => {
						this.isFilterItemsExecuted = false;
						this.items = [];
						this.total = 0;
						this.loader = false;
						this.tabChanged = false;
						const err = JSON.parse(error.request.response);
						this.$vs.notify({
							title: this.$t('words.error'),
							text: err.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					});
				} else {
					this.isFilterItemsExecuted = false;
					this.loader = false;
					this.tabChanged = false;
					this.search.attributes = [];
					this.items = [];
					this.total = 0;
				}
			} else {

				WhDocument.search(params, this.section).then(response => {
					this.isFilterItemsExecuted = false;
					this.items = response.data.items;
					this.total = response.data.total;
					this.loader = false;
					this.search.attributes = [];
				}).catch((error) => {
					this.isFilterItemsExecuted = false;
					this.loader = false;
					const err = JSON.parse(error.request.response);
					this.$vs.notify({
						title: this.$t('words.error'),
						text: err.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				});
			}

		},

		/**
		 * Format date
		 * @param date
		 * @returns {string}
		 */
		formatDate(date) {
			const split = date.split(' ');
			date = split[0];
			const revers = date.split('-');
			date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';
			return moment(String(date)).format('DD-MM-YYYY')
		},

		/**
		 * Filter columns
		 * @param columns
		 * @returns {*[]}
		 */
		filterColumns(columns = []) {
			return columns.filter(column => {
				if (column.visible) {
					column.label = this.$t(column.label);
					return column
				}
			})
		},

		/**
		 * Column listener
		 * @param $event
		 */
		columnListener($event) {
			setTimeout(() => {
				this.fields = this.filterColumns($event)
			}, 200)

		},

		/**
		 * Show confirmation
		 * @param item
		 */
		showConfirm(item) {
			let refName = 'popover' + item;
			this.$refs[refName].$emit('open')
		},

		/**
		 * Show confirmation
		 * @param item
		 */
		approveConfirm(item) {
			let refName = 'approve' + item;
			this.$refs[refName].$emit('open')
		},


		/**
		 * Close confirmation
		 * @param item
		 */
		closeConfirm(item) {
			let refName = 'popover' + item;
			this.$refs[refName].$emit('close')
		},

		/**
		 * Close confirmation
		 * @param item
		 */
		closeApprove(item) {
			let refName = 'approve' + item;
			this.$refs[refName].$emit('close')
		},


		/**
		 * Delete item
		 * @param id
		 */
		remove(id) {
			WhDocument.remove(id).then(response => {
				setTimeout(() => {
					this.loadIncomes();
				}, 200)
			})
		},

		/**
		 * Filter columns
		 * @param $event
		 */
		filterItems($event) {
			this.isFilterItemsExecuted = true;
			this.paramsFromSearch = $event.attr
			this.search.attributes = $event.attr;
			this.filterSearch = $event.filter;
			if (Array.isArray($event)) {
				if ($event.length == 0 && this.search.page !== 1) {
					return 0;
				}
			}
			this.loadIncomes();
		},

		async updateList(p, tab) {
			await this.$router.push(`${this.$route.path}?page=${p}&tab=${tab}`)
		},
		/**
		 * set columns
		 */
		setColumns() {
			if (this.isKirim) {
				if (this.activeTab == 1) {
					this.fields = this.filterColumns(this.columnsPendingIncomes);
				} else {
					this.fields = this.filterColumns(this.columnsIncome);
				}
			} else if (this.isChiqim) {
				this.fields = this.filterColumns(this.columnsOutcome);
			} else if (this.isTransfer) {
				this.fields = this.filterColumns(this.columnsTransfer);
			} else if (this.isOff) {
				this.fields = this.filterColumns(this.columnsOff)
			}

		}
	},
	computed: {
		/**
		 * Getters
		 */
		...mapGetters('warehouse', [
			'columnsIncome', 'columnsPendingIncomes', 'columnsOutcome', 'columnsTransfer', 'columnsOff'
		]),
		...mapState('warehouse',['pageStore']),
		/**
		 * Check if isKirim
		 * @returns {boolean}
		 */
		isKirim() {
			return this.section === 'kirim';
		},
		/**
		 * Chek if is Chiqim
		 * @returns {boolean}
		 */
		isChiqim() {
			return this.section === 'chiqim';
		},

		/**
		 * Check if is Transfer
		 * @returns {boolean}
		 */
		isTransfer() {
			return this.section === 'kochirish';
		},

		/**
		 * Check if is Off
		 * @returns {boolean}
		 */
		isOff() {
			return this.section === 'spisat';
		},

		/**
		 * columns
		 * @returns {*}
		 */
		columns() {
			if (this.isKirim) {
				return this.columnsIncome
			}
			if (this.isChiqim) {
				return this.columnsOutcome
			}
			if (this.isTransfer) {
				return this.columnsTransfer
			}
			if (this.isOff) {
				return this.columnsOff
			}
		}

	},

	/**
	 * Mounted
	 */
	mounted() {
		setTimeout(() => {
			this.setColumns();
		}, 200)

	},

	/**
	 * Watches
	 */
	watch: {

		/**
		 * page index
		 */
		'$route.query.page':{
			async handler(v) {
				this.$set(this.search, 'page', Number(v))
				await this.loadIncomes()
			}
		},
		'search.page': {
			handler() {
				if (!this.isTabChanged) {
					this.loadIncomes()
					// if (this.customTabIndex == 0 && this.section !== 'kirim') {
					// 	this.loadIncomes();
					// 	return 1;
					// }
					// if (this.customTabIndex == 1 && this.section !== 'kirim') {
					// 	this.loadOldTransfer();
					// 	return 1;
					// }
					// if (this.customTabIndex == 2 &&this.section !== 'kirim') {
					// 	this.loadPendings();
					// 	return 1;
					// }
					// if (this.section == 'kirim') {
					// 	this.loadIncomes();
					// 	return 1;
					// }
				}
				// if (this.isOff && this.isTabChanged) {
					// this.loadIncomes();
					// return 1;
				// }
			}
		},

		/**
		 * route path
		 */
		// '$route': {
		// 	handler() {
		// 		if (this.isKirim) {
		// 			this.$refs.filterRef.clearParams();
		// 			this.filterSearch = {}
		// 			this.paramsFromSearch = null
		// 			this.search.page = 1;
		// 			this.setColumns();
		// 		}
		// 	}
		// },
	}
};

export default Income;
